import { Button } from "antd";
import AuthorisedContainer from "components/AuthorisedContainer";
import { TableContainer } from "components/TableContainer";
import { PermissionSetMap } from "constants/RBACConstants";
import useTierBasedTagData from "hooks/useTierBasedTagData";
import _ from "lodash";
import React from "react";
import { getTagKey  } from "utils/tierUtil";

function TierBasedTagField({
  allTags,
  tier,
  tierBasedTags,
  onChange,
  value,
  editMode = true,
  permission = PermissionSetMap.UPDATE_GLOBAL_SETTING
}) {
  const { addTagsClick, columns, modalContext } = useTierBasedTagData({
    onChange,
    value,
    allTags,
    tier,
    tierBasedTags,
    actionTitle: "",
    editMode,
    permission
  });

  return (
    <>
      {modalContext}
      <TableContainer
        columns={columns}
        dataSource={value ?? []}
        rowKey={getTagKey}
      />
      <div className="d-flex justify-content-flex-end">
        <div className="m-r-sm text-bold">
          Total Asset Weighting:{" "}
          {_.reduce(value, (acc, curr) => acc + curr.value, 0)}
        </div>
        {editMode ? (
          <AuthorisedContainer permission={permission}>
            <Button size="small" onClick={addTagsClick}>
              Add Tags
            </Button>
          </AuthorisedContainer>
        ) : null}
      </div>
    </>
  );
}

export default TierBasedTagField;
